/// <summary name='cafm.actions' type='Object'>CAFM Actions object used to call HTTP actions</summary>
cafm.actions = {

    objectInContextId: null,

    add: function (a) {
        /// <summary>Adds a CAFM Action to the actions collection</summary>
        /// <param name="a" type="cafm.actions.Action">The action object to add</param>
        /// <returns type="cafm.actions.Action">The action</returns>

        cafm.actions[a.id] = a;
        return a;
    },
    get: function (id) {
        /// <summary>Gets a CAFM Action that was added to the actions collection</summary>
        /// <param name="id" type="String">The action identifier</param>
        /// <returns type="cafm.actions.Action">The action</returns>

        return cafm.actions[id];
    },
    load: function (a) {
        /// <summary>Adds a CAFM Action to the actions collection and calls its load function</summary>
        /// <param name="a" type="cafm.actions.Action">The action object to add</param>
        /// <returns type="cafm.actions.Action">The action</returns>

        a.load();
        return cafm.actions.add(a);
    },
    execute: function (opts) {
        /// <summary>Creates a CAFM Action and calls its execute function</summary>
        /// <param name="opts" type="Object">The action options</param>
        
        var exe = function () {

            new cafm.actions.Action(opts).execute();
        }

        // if true then we just want a very small delay to allow other code to run after this call to execute
        if (opts.executeDelay === true) {

            opts.executeDelay = 10;
        }

        if (opts.executeDelay) {

            if (opts.executeDelayId) {

                clearTimeout(opts.executeDelayId);
                window[opts.executeDelayId] = setTimeout(exe, opts.executeDelay);
            }
            else {

                setTimeout(exe, opts.executeDelay);
            }

        }
        else {

            exe();
        }
    },
    getResponseObject: function(e){

        cafm.actions.execute({
            url: e.url,
            method: 'GET',
            suppressErrors: e.suppressErrors,
            sync: e.sync,
            timeout: e.timeout,
            requestDelay: e.requestDelay,
            statusCodeFuncs: {

                200: function (r) {

                    if (isFunc(e.callback)) {
                        e.callback(r);
                    }
                }
            },
            error: function () {

                if (isFunc(e.fallback)) {
                    e.fallback();
                }
            },
            complete: function () {

                if (isFunc(e.complete)) {
                    e.complete();
                }
            }
        });
    },
    getObjectInContextId: function () {

        return cafm.actions.objectInContextId;
    },
    setObjectInContextId: function (id) {

        cafm.actions.objectInContextId = id;
    },
    confirmationDialogue: function (e) {

        var win;

        var cont = $('<div />', {
            'class': 'dlgContainer'
        });

        var msg;
        if (e.message) {

            msg = $('<div />', {
                'class': 'msgPnl',
                'css': {
                    'display': 'none'
                }
            });

            cont.append(msg);
        }

        var buttons = $('<menu />', {
            'class': 'dlgButtons cTb'
        });

        if (cafm.util.hasItem(e.options)) {

            e.options.forEach(function (option) {

                if (buttons.children().length) {

                    buttons.append('<span class="button-spacer"></span>');
                }

                buttons.append($('<button/>', {

                    'class': 'btn',
                    'data-key': option.Value,
                    'text': option.Label,
                    'click': function (args) {

                        option.Selected = true;

                        switch (option.ActionType) {

                            case cafm.enums.InteractionOptionType.Command:
                            case cafm.enums.InteractionOptionType.Continue:

                                var res;
                                if (isFunc(e.confirmHandler)) res = e.confirmHandler(args, option);
                                if (isUndefined(res) || res === true) win.close();
                                break;

                            default:

                                if (isFunc(e.cancelHandler)) e.cancelHandler(args, option);
                                win.close();
                                break;
                        }
                    }

                }))
            });
        }
        else {

            buttons.append($('<button/>', {

                'class': 'btn',
                'data-key': 'Continue',
                'text': e.button1Text || cafm.res.str.TextContinue,
                'click': function (args) {

                    var res;
                    if (isFunc(e.confirmHandler)) res = e.confirmHandler(args);
                    if (isUndefined(res) || res === true) win.close();
                }

            })).append('<span class="button-spacer"></span>').append($('<button/>', {

                'class': 'btn',
                'data-key': cafm.res.str.TextCancel,
                'text': e.button2Text || cafm.res.str.TextCancel,
                'click': function (args) {

                    if (isFunc(e.cancelHandler)) e.cancelHandler(args);
                    win.close();
                }
            }));
        }

        if (isJQuery(e.element)) {

            cont.append(e.element)
        }

        cont.append(buttons).appendTo(body);

        var winOpts = {
            draggable: false,
            resizable: false,
            actions: {},
            modal: true,
            title: e.title,
            visible: false,
            close: function (wargs) {

                cafm.util.callFunctionAsync({
                    func: function () {

                        cafm.util.kendoDestroy(wargs.sender.wrapper);
                        wargs.sender.wrapper.remove();
                    },
                    timeout: 500
                });
            }
        };

        win = cont.kendoWindow(winOpts).data('kendoWindow');

        if (e.message) {

            msg.showMessage({

                Title: e.message,
                Type: e.messageType ? e.messageType : cafm.enums.MessageType.Untyped
            });
        }

        if (!e.manualVisibility) {

            win.center();
            win.open();
        }

        if (!e.title) {

            win.wrapper.find('.k-header').remove();
            var top = parseInt(win.wrapper.css('top').replace('px', '')),
                diff = parseInt(win.wrapper.css('padding-top').replace('px', ''));
            win.wrapper.css('top', (top - diff) + 'px');
            win.wrapper.css('padding-top', 0)
        }

        $(window).resize(function () {

            win.center();
        });

        return win;
    },
    dataCaptureForm: function (dataCapReq, action) {
        
        cafm.views.openActionWindow({
            url: cafm.url.get('task/datacapture'),
            values: dataCapReq,
            method: 'POST',
            isForm: true,
            preventWinClose: true,
            onInit: function (panel) {

                cafm.actions.dataCaptureToolbar = {}
                var handle = function (handleArgs) {

                    var capEl = $('#' + cafm.res.consts.ElementId_DataCaptureForm),
                        buttonKey = $(handleArgs.currentTarget).data('key'),
                        option = cafm.util.find(dataCapReq.Options, function (o) { return o.Value == buttonKey });

                    if (option.ActionType != cafm.enums.InteractionOptionType.Cancel && capEl.validateElement()) {

                        dataCapReq.Options.forEach(function (o) { o.Selected = false });
                        option.Selected = true;
                        dataCapReq.Data = kendo.stringify(capEl.getParentViewModel().toJSON(), cafm.actions.stringifyFieldExcluder);
                        action.values.DataCaptureRequest = dataCapReq;
                        action.execute();
                        cafm.views.closeActionWindow($('#dataCaptureForm').closest(isMobile ? '.actionPanel ' : '.k-window-content'));
                    }
                    else if (option.ActionType == cafm.enums.InteractionOptionType.Cancel) {

                        action.execute();
                        cafm.views.closeActionWindow($('#dataCaptureForm').closest(isMobile ? '.actionPanel ' : '.k-window-content'));
                    }
                }
                panel.find('.cTb .btn').each(function (i, btn) {
                    cafm.actions.dataCaptureToolbar[$(btn).data('key').toLowerCase()] = handle;
                });
            },
            onLoad: function (panel) {

                if(action.ref) cafm.handlers.exe('dataCapture.{0}.load'.format(action.ref), panel);
            },
            winOptions: {
                title: dataCapReq.Title,
                width: cafm.views.actionWindowConfig.medium.width(),
                minHeight: 200
            },
            viewModel: {}
        })
    },
    stringifyFieldExcluder(key, value) {
        if (!key.startsWith('_')) {
            return value;
        }
    },
    actionArgs: {
            id: 'cafmActionId',
            init: function (atts) {
                /// <summary>Triggered after the action constructor is called</summary>
                /// <param name="atts" type="Object">The action options</param>

                if (!atts) atts = {}
                // call the base kendo init method
                kendo.data.Model.fn.init.call(this, atts);
                // bind load func
                this.bind('Load', this.load);

                if (atts.setValues)
                    this.bind('SetValues', atts.setValues);
                else
                    this.bind('SetValues', function () { this.set({ values: {} }); });

                // bind validate func
                if (atts.validate)
                    this.bind('Validate', atts.validate);
                else if (this.validate)
                    this.bind('Validate', this.validate);
                else
                    this.bind('Validate', function () { this.set({ valid: true }); });
                // bind execute func
                this.bind('Execute', this.execute);
            },
            load: function () {
                /// <summary>Load event for the action</summary>

                if (this.get('elementId')) {
                    var el = $('#{0}'.format(this.get('elementId')));
                    if (el.length) {
                        var v = el.kendoValidator().data("kendoValidator"); // setup the validator now so the fields validate on focus
                        cafm.kendo.ext.validator.modify(v);
                    }
                }
            },
            execute: function (e) {
                /// <summary>Execute the action and call the associated AJAX API</summary>
                /// <param name="e" type="Object">The optional DOM event</param>

                if (!e) e = {};

                if (!this.get('keepMessages')) {

                    this.hideMessage();
                }

                /* START - Prevent swarms of requests */

                // check the exe timestamp to ensure no action instances are executed more than once a second
                var exeTs = this.get('exeTimestamp'), exeNow = cafm.util.getTime(), exeDiff, exeDiffAllowance = this.get('exeDiffAllowance');
                if (exeTs) {

                    // calculate exe diff
                    exeDiff = exeNow - exeTs;
                }

                if (!exeDiffAllowance) {

                    exeDiffAllowance = 1000;
                }

                // check exe diff is not less than a second
                if (isDefined(exeDiff) && exeDiff < exeDiffAllowance) {

                    return;
                }

                // set exe timestamp
                this.set('exeTimestamp', exeNow);

                /* END - Prevent swarms of requests */

                var loaderElement = this.showLoader();

                try {
                    if (isUndefined(this.get('values'))) {
                        this.trigger('SetValues', this);
                        e.values = this.get('values');
                    }
                    else {
                        e.values = this.get('values');
                    }

                    if (!this.get('preventValidate')) {
                        var pv = this.get('preValidate');
                        if (isFunc(pv))
                            pv(this);
                        var el = this.getElement();
                        if (el && el.length) {
                            var v = el.kendoValidator().data("kendoValidator");
                            cafm.kendo.ext.validator.modify(v);
                            if (v && !v.validate()) {
                                if (e.event && isFunc(e.event.preventDefault)) e.event.preventDefault();
                                this.set({ valid: false });

                                var onInvalid = this.get('onInvalid');
                                if (isFunc(onInvalid)) {

                                    onInvalid(this);
                                }
                            }
                            else
                                this.set({ valid: true });
                        }
                        else
                            this.set({ valid: true });

                        var invalidByHandler;
                        if (this.get('valid')) {

                            this.trigger('Validate', this, e && e.event ? e.event : null);
                            invalidByHandler = this.get('valid') == false;
                        }

                        if (!this.get('valid')) { // problem with validation

                            if (!this.get('preventValidationMessage') || invalidByHandler) {

                                var msg = this.get('validationMessage');
                                if (msg == null) {

                                    msg = cafm.res.str.MessageInvalidInput;
                                }

                                this.showMessage({ Type: cafm.enums.MessageType.Error, Title: msg });
                            }
                            throw new Error();
                        }
                    }

                    var me = this;
                    me.callExeWorker = function (me) {

                        var rd = me.get('requestDelay'), ri = me.get('requestInterval');

                        // if not explicity specified then delay by 0.25 second;
                        // this is primarily to allow time for view models to update / refresh,
                        // and to help avoid actions being "too quick"
                        if (isUndefined(rd)) {

                            rd = 250;
                        }

                        var exec = function () {

                            if (ri) {

                                if (!me.interval) {

                                    me.executeWorker(e, loaderElement);
                                    me.interval = setInterval(function () {

                                        me.executeWorker(e, loaderElement);
                                    }, ri);
                                }
                                else {

                                    me.executeWorker(e, loaderElement);
                                }
                            }
                            else if (rd > 0) {
                                setTimeout(function () {
                                    me.executeWorker(e, loaderElement);
                                }, rd);
                            }
                            else {
                                me.executeWorker(e, loaderElement);
                            }
                        }

                        if ((me.confirmationPromptMessage || me.confirmationPrompt) && (!cafm.util.getReference('confirmationPrompt.isPromptRequiredHandler', me) || cafm.util.callFunction(me.confirmationPrompt.isPromptRequiredHandler, me) === true)) {

                            me.hideLoader(loaderElement);

                            var cpm = me.actualConfirmationPromptMessage || me.confirmationPromptMessage;
                            if (!cpm) cpm = me.confirmationPrompt.message;
                            cpm = cpm.dataFormat(me.values);

                            cafm.util.yesNoDialogue({
                                title: cafm.res.str.MessageConfirmationRequired,
                                message: cpm,
                                messageType: cafm.enums.MessageType.Untyped,
                                yesHandler: function () {

                                    loaderElement = me.showLoader()
                                    exec(me);
                                },
                                button1Text: me.confirmationPrompt ? me.confirmationPrompt.button1Text : '',
                                button2Text: me.confirmationPrompt ? me.confirmationPrompt.button2Text : ''
                            })
                        }
                        else {

                            exec(me);
                        }
                    }

                    var preExeCon = me.get('preExecuteConstraint');
                    if (isFunc(preExeCon)) {

                        preExeCon();
                    }

                    var exeCon = me.get('executeConstraint');
                    if (isFunc(exeCon)) {
                        me.checkExeCon = function (me) {
                            if (!exeCon(me)) {
                                setTimeout(function () {
                                    me.checkExeCon(me);
                                }, 1000);
                            }
                            else {
                                me.callExeWorker(me);
                            }
                        }
                        me.checkExeCon(me);
                    }
                    else {
                        me.callExeWorker(me);
                    }
                }
                catch (err) {
                    this.hideLoader(loaderElement);
                }
            },
            executeWorker: function (e, loaderElement) {
                /// <summary>Execute the action and call the associated AJAX API, not to be called directly</summary>
                /// <param name="e" type="Object">The action execute parameters</param>

                var me = this;

                var url = me.get('url');
                if (!url)
                    throw Error('URL not defined for action {0}'.format(me.get('Description')));
                if (isFunc(url))
                    url = url(me);

                var meth = me.get('method');
                if (!meth)
                    meth = 'POST';
                else
                    meth = me.get('method').toUpperCase();

                var values = e.values;

                if (meth == 'GET' && values && JSON.stringify(values) == '{}') {

                    values = null;
                }

                var cache;
                if (isDefined(me.get('cache'))) {
                    cache = me.get('cache');
                }

                if (values && isFunc(values.toJSON)) {
                    let valConvFunc = me.get('valuesConverter');
                    if (isFunc(valConvFunc)) {
                        valConvFunc(values);
                    }
                    values = values.toJSON();
                }

                var valuesJson;
                if (values) {

                    // ensure stamp on dtos
                    if (!isArray(values) && !isArray(values.Stamp)) {

                        // only do this for helpdesk work order views at the moment
                        var n = cafm.enums.Navigatable;
                        var navigs = [n.HelpdeskEditWorkOrder, n.HelpdeskNewWorkOrder, n.HelpdeskConfirmWorkOrder];
                        if (navigs.indexOf(cafm.nav.navigatable) > -1 && !isNullOrUndefined(cafm.hd.workOrder)) {

                            values.Stamp = cafm.hd.workOrder.Stamp;
                        }
                    }

                    var beforeExe = me.get('beforeExecute');
                    if (isFunc(beforeExe)) {

                        if (beforeExe({ action: me, values: values }) === false) {

                            return false;
                        }
                        else {

                            me.executedValues = values;
                        }
                    }

                    valuesJson = kendo.stringify(cafm.util.allDatesToUtc(values), cafm.actions.stringifyFieldExcluder);
                }

                // set values to persist from client to the server, such as current module, object in context ID etc
                // this is to avoid using the session server side and hitting concurrency issues over multiple browser tabs
                cafm.web.funcs.setCookie();

                if (!me.get('download')) {

                    var scf = this.get('statusCodeFuncs');
                    var cs = cafm.getClientSettings();

                    // ensure the timeout
                    var tout = me.get('timeout');
                    if (!tout || tout < 1000) {

                        tout = cafm.isOffline() ? cs.ajaxTimeoutOffline : cs.ajaxTimeout;
                    }

                    var ajaxOpts = {

                        url: unescape(url),
                        type: meth,
                        global: false,
                        cache: cache,
                        contentType: 'application/json',
                        dataType: 'json',
                        processData: me.get('processData') ? me.get('processData') : false,
                        data: valuesJson,
                        async: me.get('sync') ? false : true,
                        timeout: tout,
                        beforeSend: function (r, s) {

                            // check for a before send handler and call it if there is one
                            let bs = me.get('beforeSend');
                            if (isFunc(bs)) bs(r, s, me);
                        },
                        complete: function (r, s, m) {

                            var confPrompt;

                            try {

                                // TODO: determine complete action exit types and change loader hiding accordingly
                                cafm.util.callFunctionAsync({
                                    func: function () {
                                        me.hideLoader(loaderElement, [200, 204].indexOf(r.status) > -1);
                                    }, timeout: 250
                                });

                                var c = me.get('complete');
                                if (isFunc(c)) {

                                    c(r, s, m, me);
                                }

                                var wm = r.getResponseHeader(cafm.res.consts.ResHeader_WarningMessage);
                                if (wm) {

                                    me.showMessage({
                                        Title: wm,
                                        Type: cafm.enums.MessageType.Warning
                                    });
                                }

                                var resJson = r ? r.responseJSON : null;
                                confPrompt = resJson ? resJson.ConfirmationPrompt : null;

                                if (confPrompt && confPrompt.ConfirmationRequired) {

                                    if (me.values.toJSON) me.values = me.values.toJSON();

                                    if (isArray(me.values)) {
                                        me.values.forEach(function (item) {
                                            item.ConfirmationPrompt = confPrompt;
                                        })
                                    }
                                    else {
                                        me.values.ConfirmationPrompt = confPrompt;
                                    }

                                    var msgContainer = $('<div/>'), promptWin;

                                    promptWin = cafm.actions.confirmationDialogue({
                                        title: confPrompt.Title || cafm.res.str.MessageConfirmationRequired,
                                        message: confPrompt.Message,
                                        options: confPrompt.ConfirmationOptions,
                                        confirmHandler: function (args, option) {
                                            // DEBUG CHECK:
                                            if (!me.values) {
                                                cafm.msg.showMessageInWindow({
                                                    title: 'Cannot set confirmed flag as there are no values to send.',
                                                    type: cafm.enums.MessageType.Error
                                                })
                                                return;
                                            }

                                            if (option.ActionType == cafm.enums.InteractionOptionType.Command && option.Value == cafm.res.consts.DataValue_YesProceedToDataCapture) {
                                                cafm.actions.dataCaptureForm(resJson.DataCaptureRequest, me);
                                            }
                                            else {
                                                if (isArray(me.values)) {
                                                    me.values.forEach(function (item) {
                                                        item.ConfirmationPrompt.Confirmed = true;
                                                    })
                                                }
                                                else {
                                                    me.values.ConfirmationPrompt.Confirmed = true;
                                                }
                                                me.execute();
                                            }
                                        }
                                    });
                                }
                            }
                            finally {

                                // clear confirmation prompt object if confirmation was not needed
                                if (!cafm.util.getReference('ConfirmationRequired', confPrompt) && cafm.util.getReference('values.ConfirmationPrompt', me)) {

                                    delete me.values.ConfirmationPrompt;
                                }
                            }

                        },
                        error: function (r, s, m) {

                            // when offline we get a 404 or timeout so handle that here
                            if (cs.offlineEnabled && (!r.status || r.status === 404 || m === 'timeout')) {

                                cafm.setOffline(true);
                                cafm.views.showOfflineMessage();

                                if (me.get('offlineActionType')) {

                                    cafm.offline.addAction({
                                        key: values ? values._key : null,
                                        type: me.get('offlineActionType'),
                                        json: valuesJson
                                    });
                                }

                                var fb = me.get('fallback');
                                if (isFunc(fb)) {

                                    fb();
                                }
                            }
                            else if (!r.status && !me.get('suppressErrors') && !cafm.isOffline()) {

                                cafm.msg.showMessageInWindow({
                                    type: cafm.enums.MessageType.Error,
                                    title: cafm.res.str.MessageConnectionError,
                                    closeOnClick: true
                                });
                            }

                            var e = me.get('error');
                            if (isFunc(e)) {

                                e(r, s, m, me);
                            }
                        },
                        success: function (r) {

                            if (cs.offlineEnabled && cafm.isOffline()) {

                                cafm.setOffline(false);
                            }

                            if (me.get('success') && !cafm.util.getReference('ConfirmationPrompt.ConfirmationRequired', r)) {

                                cafm.util.callFunction(me.get('success'), r, me);
                            }
                        },
                        statusCode: {

                            200: function (r, s, m) {
                                me.callStatusCodeFunc(scf, '200', r, s, m, me);
                            },
                            204: function (r, s, m) {
                                me.callStatusCodeFunc(scf, '204', r, s, m, me);
                            },
                            400: function (r, s, m) {
                                me.handleError(unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage)));
                                me.callStatusCodeFunc(scf, '400', r, s, m, me);
                            },
                            302: function (r, s, m) { // treat 302 as 401, as the only time an AJAX request will redirect is when the client is not authenticated.

                                if (!scf || !scf['401']) {
                                    cafm.auth.notAuthenticated(true);
                                }
                                else {

                                    scf['401'](r, s, m, me);
                                }
                            },
                            401: function (r, s, m) {

                                if (!scf || !scf['401']) {
                                    cafm.auth.notAuthenticated(true);
                                }
                                else {

                                    scf['401'](r, s, m, me);
                                }
                            },
                            403: function (r, s, m) {
                                me.handleError(unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage)), unescape(r.responseText));
                                me.callStatusCodeFunc(scf, '403', r, s, m, me);
                            },
                            404: function (r, s, m) {

                                var oe = cafm.getClientSettings().offlineEnabled;

                                if (!oe) {

                                    var msg = unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage));
                                    var txt = unescape(r.responseText);
                                    if (!cafm.util.hasStringVal(msg) && !cafm.isOffline()) {

                                        msg = cafm.res.str.MessageResourceNotFound;
                                    }
                                    me.handleError(msg, txt);
                                    me.callStatusCodeFunc(scf, '404', r, s, m, me);
                                }
                            },
                            409: function (r, s, m) {
                                me.callStatusCodeFunc(scf, '409', r.responseJSON, s, m, me);
                            },
                            500: function (r, s, m) {
                                if (!me.preventDefaultErrorHandling) me.handleError(unescape(r.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage)), r.responseText, 500);
                                me.callStatusCodeFunc(scf, '500', r, s, m, me);
                            }
                        }
                    };

                    cafm.web.keepAlive.updateLastServerActivity();

                    $.ajax(ajaxOpts);
                }
                else {

                    cafm.util.download(url, valuesJson, meth);
                }
            },
            handleError(m, d, sc) {
                let me = this;
                let fallbackError = () => {
                    if (!cafm.util.hasStringVal(m) && sc && sc == 500) {
                        m = cafm.res.str.MessageServerError;
                        let cs = cafm.getClientSettings();
                        if (cs.sendStackTraceToClient && d.indexOf('{') > -1) {
                            d = cafm.util.formatServerError(d);
                        }
                        else {
                            d = null;
                        }
                    }
                    if (cafm.util.hasStringVal(m)) {
                        me.showMessage({
                            Type: cafm.enums.MessageType.Error,
                            CssClass: 'exceptionView',
                            Title: m,
                            Html: cafm.util.convertLineBreaks(d)
                        });
                    }
                }
                if (cafm.util.hasStringVal(m) || cafm.util.hasStringVal(d)) {
                    if (this.get('suppressErrors')) {
                        console.error(m);
                    }
                    else {
                        let opts = {
                            Type: cafm.enums.MessageType.Error,
                            CssClass: 'exceptionView'
                        };
                        if (this.get('errorMessageTitle')) {
                            opts.Title = '{0}: {1}'.format(this.get('errorMessageTitle'), m);
                            opts.Html = cafm.util.convertLineBreaks(d);
                        }
                        else {

                            if (!cafm.util.hasStringVal(m) && sc && sc == 500) {

                                fallbackError();
                                return;
                            }

                            opts.Title = m;
                            opts.Text = d;
                        }

                        this.showMessage(opts);
                    }
                }
                else {

                    fallbackError();
                }
            },
            getElement() {
                /// <summary>Gets the element associated with the action, typically the form / container element</summary>
                /// <returns type="JQuery">The element, null if there is no elementId set on the action</returns>

                if (this.get('elementId'))
                    return $('#{0}'.format(this.get('elementId')));
                else if (this.get('element'))
                    return this.get('element');
                else
                    return null;
            },
            getMessageElement() {
                /// <summary>Gets the message element associated with the action</summary>
                /// <returns type="JQuery">The element, or $('#msgPanel') if no message panel is inside the actions container element</returns>

                let element = this.getElement();
                if (element) {
                    let mp = $('.msgPnl:not(.staticMsgPnl):first,.popupMsg:not(.staticMsgPnl):first', element);
                    if (mp.length) {

                        return mp;
                    }
                }
                return $('#msgPanel');

            },
            showMessage(o, onCloseFunc) {
                /// <summary>Shows a message associated with the action</summary>
                /// <param name="o" type="Object">The message options</param>

                let msgElement = this.getMessageElement();
                if (!this.showMessageInWindow && msgElement.length) {
                    msgElement.showMessage(o);
                }
                else {
                    cafm.msg.showMessageInWindow({
                        type: o.Type,
                        title: o.Title,
                        text: o.Text,
                        cssClass: o.CssClass,
                        closeOnClick: o.Type != cafm.enums.MessageType.Error,
                        onClose: onCloseFunc
                    });
                }
            },
            hideMessage() {
                /// <summary>Hides a message associated with the action</summary>

                this.getMessageElement().not('.staticMsgPnl').hideMessage(true);
            },
            showLoader() {
                let lt;
                let ls = this.get('loaderSelector');
                if (ls) {
                    lt = $(ls);
                }
                else {
                    let targ = this.get('loaderTarget');
                    if (targ)
                        lt = $(targ);
                }
                if (lt && lt.length) {
                    let ld = this.get('loaderDelay');
                    let res = lt.showLoader({
                        text: this.get('loaderText'),
                        isInPlaceLoader: this.get('usesInPlaceLoader'),
                        timeout: ld
                    });
                    if (ld && !isJQuery(res)) this.loaderTimeout = res;
                }
            },
            hideLoader(loaderElement, s) {
                let ltr = this.get('loaderTimeout');
                if (isDefined(ltr)) {
                    clearTimeout(ltr);
                    delete this.loaderTimeout;
                }
                let lt = loaderElement;
                if (!loaderElement) {
                    let ls = this.get('loaderSelector');
                    if (ls) {
                        lt = $(ls);
                    }
                    else {
                        let targ = this.get('loaderTarget');
                        if (targ)
                            lt = $(targ);
                    }
                }
                if (lt && lt.length) {
                    lt.hideLoader({ success: s });
                }
            },
            callStatusCodeFunc(scf, c, r, s, m, me) {
                if (scf && scf[c]) scf[c](r, s, m, me);
            }
        },
    init: function (args) {

        cafm.actions.Action = kendo.data.Model.define(cafm.actions.actionArgs);
    }
}